import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class ToastrComponent {

    constructor(private toastr: ToastrService) { }

    mostrarMensagem(tipo: string, titulo: string, texto: string) {

        switch (tipo) {
            case 'sucesso':
                this.toastr.success(texto, titulo, { enableHtml: true });
                break;
            case 'erro':
                this.toastr.error(texto, titulo, { enableHtml: true });
                break;
            case 'info':
                this.toastr.info(texto, titulo, { enableHtml: true });
                break;
            case 'aviso':
                this.toastr.warning(texto, titulo, { enableHtml: true });
                break;
            default:
                break;
        }
    }
}
